<ng-container *ngIf="!(isAtDeclineWarningState$ | async) else updatedTermsAndConditionsDeclined">
	<ng-container *ngIf="termsAndConditionsHistoryEnabled; else regularTermsAndConditions">
		<mat-tab-group
			*ngIf="(isAuthenticated$ | async) else anonymous"
			[dynamicHeight]="false"
			[selectedIndex]="selectedIndex"
			(selectedTabChange)="selectTab($event.index)"
		>
			<mat-tab>
				<ng-template mat-tab-label>
					<span test-id="terms-and-conditions-current-section">
						{{ 'terms-and-conditions.current-version-header' | translate }}
					</span>
				</ng-template>
				<ng-template matTabContent>
					<obg-content-section-group-container
						hideBanner
						disableScrollToCurrentFragment
						document="terms-and-conditions"
						[keysToBeUsedWithinDocumentType]="currentVersion?.resourceKeys"
					>
					</obg-content-section-group-container>
				</ng-template>
			</mat-tab>

			<mat-tab>
				<ng-template mat-tab-label>
					<span test-id="terms-and-conditions-history-section">
						{{ 'terms-and-conditions.history-header' | translate }}
					</span>
				</ng-template>
				<ng-template matTabContent>
					<ng-container *ngTemplateOutlet="termsAndConditionsHistory"></ng-container>
				</ng-template>
			</mat-tab>

			<ng-template #termsAndConditionsHistory>
				<obg-m-sm-terms-and-conditions-history-container
					[termsAndConditionsDocumentsHistory]="versionHistory"
					[jurisdiction]="jurisdiction"
				></obg-m-sm-terms-and-conditions-history-container>
			</ng-template>
		</mat-tab-group>

		<ng-template #anonymous>
			<obg-content-section-group-container
				hideBanner
				disableScrollToCurrentFragment
				document="terms-and-conditions"
				[keysToBeUsedWithinDocumentType]="(latestVersion$ | async)?.resourceKeys"
			>
			</obg-content-section-group-container>
		</ng-template>
	</ng-container>

	<ng-template #regularTermsAndConditions>
		<obg-content-section-group-container
			hideBanner
			disableScrollToCurrentFragment
			document="terms-and-conditions"
		></obg-content-section-group-container>
	</ng-template>
</ng-container>

<ng-template #updatedTermsAndConditionsDeclined>
	<div class="decline-content">
		<p
			class="obg-m-updated-terms-and-conditions-title"
			[innerHtml]="'terms-and-conditions.decline-updated-title' | translate"
		></p>
		<p
			class="obg-m-updated-terms-and-conditions-message"
			[innerHtml]="'terms-and-conditions.decline-updated-message' | translate"
		></p>
		<form [formGroup]="declineFormGroup" test-id="decline-terms-and-conditions-warning-form">
			<mat-checkbox
				test-id="logout-warning-checkbox"
				[class.checkbox-required]="false"
				color="primary"
				required
				formControlName="logoutWarning"
			>
				<span [innerHtml]="'terms-and-conditions.logout-warning' | translate"></span>
			</mat-checkbox>

			<mat-checkbox
				test-id="close-account-warning-checkbox"
				color="primary"
				required
				[class.checkbox-required]="false"
				class="obg-m-updated-terms-and-conditions-close-account-warning"
				formControlName="closeAccountWarning"
			>
				<span [innerHtml]="'terms-and-conditions.close-account-warning' | translate"></span>
			</mat-checkbox>
		</form>
	</div>
</ng-template>

<div class="validation-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>
